<template>
    <a class="scrollBack" href="#app" v-smooth-scroll>
        <img src="../assets/scrollUp_Icon.svg" alt="Scroll Back">
    </a>
</template>

<script>
export default {
    name:'scrollBack',
    methods: {
        getImgUrl: function(img) {
            return require('../assets/'+img)
        }
    }
}
</script>

<style>
.scrollBack {
    height:50px;
    width:50px;
    border-radius:25px;
    border:2px solid #FF2247;
    position:fixed;
    line-height:45px;
    text-align:center;
    bottom:30px;
    right:30px;
    background-color: #FF2247;
    font-weight:bold;
    animation: 2s linear 0s alternate move_eye;
}

@-webkit-keyframes move_eye { from { opacity:0 } to { opacity:1 }  }
        @keyframes move_eye { from { opacity:0 } to { opacity:1 }  }
</style>
